import React from 'react';
import PropTypes from 'prop-types';

export default function IcRefresh({ className }) {
  return(
    <svg className={className} fill="none" height="22" viewBox="0 0 16 22" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 3.00003V1.21003C8 0.760031 7.46 0.540031 7.15 0.860031L4.35 3.65003C4.15 3.85003 4.15 4.16003 4.35 4.36003L7.14 7.15003C7.46 7.46003 8 7.24003 8 6.79003V5.00003C11.31 5.00003 14 7.69003 14 11C14 11.79 13.85 12.56 13.56 13.25C13.41 13.61 13.52 14.02 13.79 14.29C14.3 14.8 15.16 14.62 15.43 13.95C15.8 13.04 16 12.04 16 11C16 6.58003 12.42 3.00003 8 3.00003ZM8 17C4.69 17 2 14.31 2 11C2 10.21 2.15 9.44003 2.44 8.75003C2.59 8.39003 2.48 7.98003 2.21 7.71003C1.7 7.20003 0.84 7.38003 0.57 8.05003C0.2 8.96003 0 9.96003 0 11C0 15.42 3.58 19 8 19V20.79C8 21.24 8.54 21.46 8.85 21.14L11.64 18.35C11.84 18.15 11.84 17.84 11.64 17.64L8.85 14.85C8.54 14.54 8 14.76 8 15.21V17Z" fill="curentColor"/>
    </svg>
  );
}

IcRefresh.propTypes = {
  className: PropTypes.string,
};

